module.exports = __webpack_public_path__ + "static/media/YF37_0.a3bc87a9.jpg";